export default {
  common: {
    more: "More",
    langShortZh: "中",
    langShortEn: "EN",
    langShortTh: "TH",
    langZh: "中文",
    langEn: "English",
    langTh: "Thai",
    searchPlaceholder: "Search attractions, guides, news...",
    loading: "Loading...",
    loadingContent: "Loading content...",
    expandMore: "Load More",
    collapse: "Collapse",
    print: "Print",
    go: "Go",
    noContent: "No content",
    comingSoon: "Coming soon",
    author: "Author: ",
    publishTime: "Published: ",
    phone: "Phone: ",
    address: "Address: ",
    backHome: "Back to Home",
    pageNotFound: "Page Not Found",
    pageNotFoundDesc:
      "The page you're looking for doesn't exist or has been moved",
    underDevelopment: "Feature under development",
    cmsConfigHint:
      "Content pending (please tag articles/media with '{tag}' in CMS)",
    noMediaContent: "No media content",
    contentConfiguring: "Content coming soon",
    pageNumber: "Page",
    defaultPublisher: "Dagu Glacier Administration",
  },
  nav: {
    "/": "Home",
    "/about": "About Dagu",
    "/about/intro/views": "Scenic Detail",
    "/about/intro": "Overview",
    "/about/honor": "Honors",
    "/about/geology": "Geology",
    "/about/glacier-research": "Folk Culture",
    "/about/RedCulture": "Red Army Culture",
    "/about/ecology": "Ecology",
    "/about/experiment": "Glacier Lab",
    "/panorama": "Panorama",
    "/panorama/live": "Live",
    "/panorama/videos": "Videos",
    "/panorama/shorts": "Shorts",
    "/panorama/gallery": "Gallery",
    "/panorama/dagu-er": "Dagu Moments",
    "/service": "Visitor Service",
    "https://www.abatour.com/": "Tickets",
    "/service/food": "Food",
    "/service/food/:id": "Food Detail",
    "/service/traffic": "Traffic",
    "/service/route": "Routes",
    "/service/stay": "Stay",
    "/service/stay/:id": "Stay Detail",
    "/service/specialty": "Specialties",
    "/service/play": "Guide",
    "/service/entertainment": "Entertainment",
    "/service/entertainment/:id": "Entertainment Detail",
    "/service/map": "Map",
    "/service/tips": "Tips",
    "/service/products": "Products",
    "/service/products/sunshine-snow": "Sunshine Snow Tour",
    "/service/products/ice-summer": "Ice Summer Tour",
    "/service/products/snow-mountain-forest": "Snow Mountain Forest Tour",
    "/service/products/glacier-science": "Glacier Science Tour",
    "/service/products/red-culture": "Red Culture Tour",
    "/service/questionnaire": "Questionnaire",
    "/service/complaints": "Complaints",
    "/gov": "Government",
    "/gov/politics": "Politics",
    "/gov/news": "News",
    "/gov/dynamic": "Culture & Tourism Updates",
    "/gov/employee": "Staff Spotlight",
    "/gov/media": "Media",
    "/gov/notices": "Notices",
    "/gov/procurement": "Procurement",
    "/gov/mailbox": "Mailbox",
    "/gov/press": "Press",
    "/marketing": "Marketing",
    "/marketing/brand": "Brand Events",
    "/marketing/promotion": "Promotion",
    "/marketing/cross": "Cross-over",
    "/marketing/mediaCare": "Media Focus",
    "/marketing/campaigns": "Campaigns",
    "/marketing/party": "Party Affairs",
    "/marketing/units": "Staff Activities",
    "/study": "Study Tour",
    "/news": "News Center",
    "/news/:id": "News Detail",
  },
  home: {
    heroTitle: "Dagu Glacier",
    heroSub: "Above the Clouds · Pure Snowland",
    altitude: "Altitude",
    realtime: "Now",
    latestNews: "Latest News",
    photoStory: "Photo Story",
    ticketing: "Ticket Booking",
    live: "Live",
    ugc: "Dagu Moments",
    glacierCover: "Glacier Blanket",
    glacierExperiment: "Glacier Lab",
    activities: "Activities",
    notices: "Official Notices",
    research: "Research",
    emptyNotice: "No notices",
    viewDetail: "View",
    ticketBooking: "Official Ticket Booking",
    consult: "Consult",
    weather: "Weather",
    liveView: "Live View",
    heroAltitude: "Altitude",
    heroOpenTime: "Opening hours",
    heroBooking: "Online booking",
    heroConsult: "Hotline",
    quickFood: "Food",
    quickStay: "Stay",
    quickRoute: "Routes",
    quickGuide: "Guide",
    quickSpecialty: "Specialties",
    quickLeisure: "Leisure",
    // Mobile specific
    mobileTicketing: "Ticket Booking",
    mobileLatestNews: "Latest News",
    quickPhotoStory: "Photo Story",
    quickLive: "Live Stream",
    quickTraffic: "Traffic",
    quickTips: "Tips",
    quickMap: "Map",
    quickProducts: "Recommended Routes",
    quickPlay: "Guide",
    quickEntertainment: "Entertainment",
    weatherGuide: "Weather",
    // Dagu Moments
    daguErTitle: "Dagu Moments",
    daguErSubtitle:
      "Capture the moment, express through photos. See Dagu through different eyes.",
    // Glacier Blanket
    glacierCoverTitle: "Glacier Blanket",
    glacierCoverText:
      "In 2020, the Chinese Academy of Sciences conducted China's first glacier 'blanketing' experiment at Dagu Glacier. By laying insulating reflective materials on the glacier surface, the melting process is slowed down, keeping the glacier largely intact.",
    // Glacier Lab
    glacierExperimentTitle: "Glacier Lab",
    glacierExperimentText:
      "Dagu Glacier offers rich study tour resources with diverse scenarios, forming a study tour product framework of '5 journeys, 1 center, 8 nodes'. It is a member of the Sichuan Province Primary and Secondary School Study Tour Base Alliance.",
    // Activities
    activitiesDesc:
      "To implement important decisions on cultural-tourism integration and expand the scenic area's brand influence, Dagu Glacier Management Bureau actively conducts various marketing activities, creating an online-offline integrated promotion pattern to enhance visibility and attraction.",
    // Online booking
    onlineBooking: "Book Online",
    officialChannel: "Official Booking Channel",
    consultPhone: "Hotline",
  },
  homeData: {
    weatherLocation: "Aba Tibetan and Qiang Autonomous Prefecture",
    weatherCondition: "Sunny",
    researchFallback1:
      "Paper: Climate Change, Natural Resources, and Sustainable Development in Dagu Glacier",
    researchFallback2:
      "Paper: Zoned Protection of Geological Heritage in Dagu Glacier Geopark",
    researchFallback3:
      "Paper: Geological Heritage Resources and Geoscientific Value of Dagu Glacier Geopark",
    researchFallback4:
      "Monograph: Mountain Glaciers and Sustainable Tourism Development",
    researchFallback5: "Dagu Glacier Continues Glacier Observation Programs",
  },
  ticket: {
    todayTicketRemaining: "Tickets sold today",
    todayCablewayRemaining: "Cableway sold today",
    sheets: "",
    highest: "High",
    lowest: "Low",
    traffic: "Traffic",
    tips: "Visitor Tips",
    map: "Map",
    products: "Routes",
    openingTime: "Opening Hours",
    weatherGuide: "Weather",
  },
  photoStory: {
    empty: 'Configure slides in CMS for "Photo Story".',
  },
  footer: {
    friends: "Friendly Links",
    surveys: "Surveys",
    qrNeed: "QR needed",
    qrScan: "Scan",
    qrSub1: "Scan to visit the mobile site",
    qrSub2: "Dagu Glacier",
    badge1: "National 4A Scenic Area",
    badge2: "National Geopark",
    badge3: "Provincial Scenic Spot",
    badge4: "Eco Tourism Demonstration",
    badge5: "Eco Civilization Base",
    consult: "Consult",
    complaint: "Complaint",
    reportPhone: "Report hotline",
    reportEmail: "Report email",
    reportCenterCn: "Internet Report Center",
    reportCenterSc: "Sichuan Report Center",
    channelDouyin: "Douyin",
    channelXiaohongshu: "Xiaohongshu",
    channelWeChat: "WeChat",
    channelWeibo: "Weibo",
    channelVoiceGuide: "Audio Guide",
    qrDouyin: "Douyin QR Code",
    qrXiaohongshu: "Xiaohongshu QR Code",
    qrWechat: "WeChat QR Code",
    qrWeibo: "Weibo QR Code",
    qrVoiceGuide: "Audio Guide QR Code",
    qrMobileSite: "Dagu Glacier Mobile Site QR Code",
    friendLinks: {
      scGov: "Sichuan Provincial Government",
      abaGov: "Aba Prefecture Government",
      jiuzhai: "Jiuzhaigou",
      huanglong: "Huanglong",
      siguniang: "Mt. Siguniang",
      abaTour: "Aba Tourism",
      cctv: "CCTV",
      sctv: "Sichuan TV",
      sina: "Sina",
    },
    surveyNationalStandard:
      "National Tourism Administration Visitor Feedback Form",
    surveySatisfaction:
      "National Tourism Administration Visitor Satisfaction Survey",
    surveyNationalStandardQuery:
      "National Tourism Administration Visitor Feedback Form",
    surveySatisfactionQuery:
      "National Tourism Administration Visitor Satisfaction Survey",
  },
  gov: {
    tabs: {
      all: "All",
      politics: "Politics",
      news: "Scenic News",
      dynamic: "Culture & Tourism Updates",
      employee: "Staff Spotlight",
      media: "Media Focus",
      notices: "Notices",
      procurement: "Procurement",
      mailbox: "Mailbox",
      press: "Press",
    },
    jump: "Go",
  },
  gallery: {
    loadMore: "Load More",
    prevImage: "Previous",
    nextImage: "Next",
    noImage: "No Image",
    untitled: "Untitled Image",
  },
  intro: {
    title: "Scenic Area Overview",
    moreContent: "Learn More",
    description:
      'Dagu Glacier Scenic Area is located on the southeastern edge of the Qinghai-Tibet Plateau, in Heishui County, Aba Prefecture, Sichuan Province. It borders Mao County Ancient Qiang City to the east, Hongyuan Grassland to the west, Bipenggou to the south, and Huanglong Scenic Area to the north. It is 260 km from Chengdu, 90 km from Hongyuan Airport, and 120 km from Mao County High-Speed Railway Station. Traversing alpine valleys without climbing mountains, immersing in snowy forests without braving snow, standing atop peaks without hiking—this is the true essence of Dagu Glacier. The scenic area offers ice and snow experiences, eco-tourism, wellness retreats, scientific research, and wedding photography. It has been designated as a National 4A Tourist Attraction, National Geopark, and Provincial Eco-Tourism Demonstration Area. As the northernmost modern maritime monsoon mountain glacier closest to a major city in China, it is known as "The Nearest Distance."',
    spots: {
      daguLake: "Dagu Lake",
      loversBeach: "Lovers' Beach",
      goldenMonkeySea: "Golden Monkey Sea",
      zenaco: "Zenaco",
      mountLogos: "Mount Logos",
      glacierSummit: "Glacier Summit 4860m",
    },
  },
  header: {
    logoAlt: "Dagu Glacier",
    searchAlt: "Search",
    dropdownAlt: "Dropdown",
  },
  video: {
    noPlayableUrl: "No playable URL available",
    unnamedVideo: "Untitled Video",
  },
  news: {
    externalLinkNotice: "This is an external link: ",
    noExternalLink: "No external link configured.",
    relatedTitle: "Related Articles",
  },
  geology: {
    comingSoon: "More geology content coming soon",
    title: "Geology",
    viewMore: "View More",
  },
  ecology: {
    title: "Ecology",
    geologySection: "Geology",
    biologySection: "Biology",
    animalOverview: "Dagu Glacier Animals",
    plantOverview: "Dagu Glacier Plants",
    noGeologyData: "No geology data available",
    noBioData: "No biology data available",
    noContent: "No content",
    moreGeologyComing: "More geology content coming soon",
    moreBioComing: "More biology content coming soon",
  },
  glacier: {
    experimentTitle: "Glacier Experiment",
    researchTitle: "Folk Culture",
    noExperimentData: "No experiment data available",
    noResearchData: "No folk culture data available",
    noRedCultureData: "No Red Army culture data available",
  },
  honor: {
    title: "Honors",
    noHonors: "No honors available",
    comingSoonHint: "More honors coming soon",
    viewMore: "View More",
  },
  modal: {
    close: "Close",
    prev: "Previous",
    next: "Next",
    imageLoadError: "Image failed to load",
  },
  live: {
    liveNow: "LIVE",
    connecting: "Connecting to stream...",
    invalidUrl: "Invalid stream URL",
    loadFailed: "Stream load failed",
    browserNotSupported: "Your browser does not support live streaming",
    title: "Live",
    loadError: "Live stream loading failed, please try again later",
    browserNotSupportedMsg:
      "Your browser does not support m3u8 playback. Please use Safari or upgrade your browser",
    clickToRetry: "Click to retry",
  },
  tips: {
    noContent: "No visitor tips available",
    comingSoon: "More visitor tips coming soon",
  },
  traffic: {
    noContent: "No traffic guide available",
    comingSoon: "More traffic guide content coming soon",
  },
  service: {
    complaintPhone: "Complaint Hotline",
  },
  serviceHomePage: {
    ticketBooking: "Ticket Booking",
    officialNotices: "Official Notices",
    openingTime: "Opening Hours",
    peakSeason: "Peak Season",
    offSeason: "Off Season",
    scenicOpenTime: "Opening hours: ",
    ticketPrice: "Ticket",
    cablewayPrice: "Cableway",
    sightseeingCarPrice: "Sightseeing Bus",
    visitorTips: "Visitor Tips",
    trafficGuide: "Traffic Guide",
    scenicMap: "Scenic Map",
    tourismProducts: "Tourism Products",
    businessRecommendation: "Recommendations",
    questionnaire: "Questionnaire",
    complaint: "Complaints",
    consultPhone: "Hotline",
    viewMap: "View Scenic Map",
    scanQRCode: "Scan QR code to fill out the questionnaire",
    configurableImage: "Configurable Image",
    mapPreviewTitle: "Scenic Map Preview",
    close: "Close",
    // Quick access
    quickOpenTime: "Opening Hours",
    quickOpenTimeSub: "08:00—17:00",
    quickBooking: "Ticket Booking",
    quickBookingSub: "Official Channel",
    quickAltitude: "Altitude",
    quickAltitudeSub: "2300—4860m",
    quickTraffic: "Traffic Guide",
    quickTrafficSub: "Travel with ease",
    quickMap: "Scenic Map",
    quickMapSub: "Plan your route",
    quickTips: "Visitor Tips",
    quickTipsSub: "Travel safely",
    // Traffic guide
    highwayRoute: "Highway",
    railRoute: "Railway",
    flightRoute: "Flight",
    trafficRoute1:
      "Chengdu → Dujiangyan → Wenchuan → Mao County → Heishui → Dagu Glacier",
    trafficRoute2:
      "Chengdu East Station (HSR) → Mao County Station → Transfer → Heishui → Dagu Glacier",
    trafficRoute3:
      "Chengdu Tianfu/Shuangliu Airport → Hongyuan Airport → Dagu Glacier",
    productsDesc:
      "Dagu Glacier offers five core tourism products: Sunshine & Ice, Summer Coolness, Colorful Forest, Glacier Science, and Red Culture. Experience the beauty of nature, science, and culture all in one place.",
    consultPhoneLabel: "Hotline",
    complaintPhoneLabel: "Complaint",
    // Price labels
    ticketLabel: "Ticket: ",
    busTicketLabel: "Bus: ",
    cablewayTicketLabel: "Cableway: ",
    ticketSalesTime: "Ticket sales: ",
    yearRound: " (All year)",
    // Prices
    peakSeasonTicketPrice: "¥120",
    peakSeasonBusPrice: "¥70",
    peakSeasonCablewayPrice: "¥180",
    offSeasonTicketPrice: "¥80",
    offSeasonBusPrice: "¥70",
    offSeasonCablewayPrice: "¥150",
    // Traffic schedules
    trafficSchedule1: "Dagu Glacier Summer Traffic Schedule",
    trafficSchedule2: "Heishui County Bus Station Schedule",
    trafficSchedule3: "Aba Bus Station Routes and Schedule...",
    tipsHalfTitle: "Half-price ticket offers",
    tipsHalfItem1:
      "1. Youth travelers: minors aged 6 to 18, undergraduate students and below, and inbound youth from Hong Kong, Macao, and Taiwan with valid documents.",
    tipsHalfItem2:
      "2. Seniors: travelers aged 60 to 64 on national statutory holidays.",
    tipsHalfItem3:
      "3. Religious groups: believers holding valid provincial-or-above religious certificates issued by authorized organizations.",
    tipsFreeTitle: "Free ticket offers",
    tipsFreeItem1:
      "1. Children under 6 years old or below 1.2 meters receive free admission, sightseeing bus, and cableway tickets.",
    tipsFreeItem2:
      "2. Seniors aged 65+ and travelers aged 60 to 64 on non-holiday dates receive free admission; sightseeing bus and cableway tickets are purchased separately.",
    tipsFreeItem3:
      "3. Active-duty soldiers, veterans, disabled soldiers, retired cadres, and designated reconstruction medal recipients receive free admission; sightseeing bus and cableway tickets are purchased separately.",
    tipsFreeItem4:
      "4. Visitors with disability certificates receive free admission. Blind visitors and travelers with severe physical, intellectual, or mental disabilities may bring one accompanying person free of charge.",
    tipsNote:
      "Eligible visitors must present valid documents such as household registration, ID card, military card, disabled soldier certificate, or retirement certificate for registration and verification.",
    // Tourism products
    productSunshineSnow: "Sunshine & Snow",
    productIceSummer: "Ice & Summer",
    productSnowMountainForest: "Snow Mountain & Forest",
    productGlacierScience: "Glacier Science",
    productRedCulture: "Red Culture",
    // Business recommendations
    bizFood: "Food",
    bizStay: "Accommodation",
    bizRoute: "Routes",
    bizPlay: "Guide",
    bizSpecialty: "Specialties",
    bizLeisure: "Entertainment",
  },
  campaignsPage: {
    title: "Campaigns",
    all: "All",
    loadMore: "Load More",
    yearSuffix: "",
  },
  govPage: {
    externalLinkNotice: "This is an external link: ",
    noExternalLink: "No external link configured.",
    loadingContent: "Loading content...",
    noContent: "No content",
    externalLink: "External Link",
  },
  govPortal: {
    pageTitle: "Government Center",
    leadershipTeam: "{'|'} Leadership Team",
    politics: "Politics",
    scenicNews: "Scenic News",
    scenicNewsPrefix: "{'|'} Scenic News",
    mediaFocus: "Media Focus",
    officialNotices: "Official Notices",
    officialNoticesPrefix: "{'|'} Official Notices",
    procurement: "Procurement",
    procurementPrefix: "{'|'} Procurement",
    mailbox: "Leadership Mailbox",
    viewMore: "View More",
    configurableImage: "Configurable Image",
    defaultName: "Name",
    defaultRole: "Title",
    defaultAddress: "Mailing Address",
    defaultText:
      "Configurable sample text for page preview and integration testing.",
    mockContentPrefix: "Sample content for page testing (",
    mockContentSuffix: ").",
    sample: "Sample",
  },
  marketing: {
    // Brand Activities
    brandTitle: "Brand Events",
    brandSubtitleDesktop:
      "Create iconic experiences, Build anticipation. With distinctive themes, create deep experiences and unique memories.",
    brandSubtitleMobile:
      "Create iconic experiences.<br>With distinctive themes, create deep experiences and unique memories.",
    brandAlt: "Brand Events",
    // Market Promotion
    promotionTitle: "Market Promotion",
    promotionSubtitle:
      "Targeting key source markets, conducting themed promotions and channel partnerships to expanding tourism with a global perspective.",
    // Cross-over
    crossTitle: "Cross-over",
    crossSubtitle:
      "Cross-sector collaboration, new cross-over models, working with various fields and renowned projects to broaden marketing channels.",
    crossPrefix: "{'|'} Cross-over",
    // Media Care
    mediaCareTitle: "Media Focus",
    mediaCareSubtitle:
      "Authoritative media attention, excellent case reports, effective dissemination through reporter columns, forming a comprehensive and efficient partnership.",
    // Campaigns
    campaignsTitle: "Campaigns",
    campaignsPrefix: "{'|'} Campaigns",
    campaignsSubtitle:
      "Online-offline integration, forming a new pattern of nationwide participation. Over 100 innovative projects throughout the most creative marketing campaign.",
    // Party Activities
    partyTitle: "Party Activities",
    partySubtitle:
      "Party building activities, leadership care, NPC and CPPCC inspections, relevant department exchanges and discussions.",
    // Staff Activities
    unitsTitle: "Staff Activities",
    unitsSubtitle:
      "Cultivating spirit and soul, professional development, regular team activities, and business competitions to drive motivation.",
    // Common
    viewMore: "View More",
    more: "More",
    morePlus: "More+",
    clickForDetails: "Click for details",
    activityTitlePlaceholder: "Activity title here!",
    configurableTitle: "Configurable Title",
    configurableImage: "Configurable Image",
    defaultDate: "2025-00-00 00:00",
  },
  backToTop: {
    label: "Back to Top",
  },
  breadcrumb: {
    currentPosition: "Current: ",
    home: "Home",
  },
  pages: {
    immersiveCloudTour: {
      liveStream: "Live Stream",
      videos: "Videos",
      shortsCollection: "Short Videos",
      more: "More",
      gallery: "Gallery",
      viewMore: "View More",
      daguEr: "Dagu Moments",
      daguErDesc:
        "Capture the moment, express through photos. See Dagu through different eyes.",
      noPlayableUrl: "No playable URL available",
      noImage: "No Image",
      unnamedVideo: "Untitled Video",
      unnamedWork: "Untitled Work",
      galleryDesc:
        "One mountain, four seasons—each a masterpiece. Dagu Glacier is a natural canvas hidden in the western Sichuan plateau, a world-class eco-tourism destination for all seasons.",
      galleryDesc2:
        "Spring brings melting ice and blooming flowers, where glaciers meet floral seas in gentle contrast. Summer offers cool retreats with lush forests and crystal lakes at 4,860m. Autumn paints the mountains in red and gold, with snow peaks dancing among colorful foliage. Winter wraps the land in pristine white, with blue ice and crystal rime revealing the pure majesty of the snowy realm.",
      seasons: {
        spring: "Spring",
        springName: "Flowers & Snow",
        springDesc1: "Spring at Dagu Glacier,",
        springDesc2: "half snow-capped peaks,",
        springDesc3: "half flowers in the valleys,",
        springDesc4: "a unique highland scene.",
        summer: "Summer",
        summerName: "Cool Retreat",
        summerDesc1: "Summer at Dagu Glacier,",
        summerDesc2: "forests embrace joy,",
        summerDesc3: "glacier lakes bring coolness,",
        summerDesc4: "a secret highland escape.",
        autumn: "Autumn",
        autumnName: "Colorful Forests",
        autumnDesc1: "Autumn at Dagu Glacier,",
        autumnDesc2: "red leaves ignite the forests,",
        autumnDesc3: "glaciers enhance the colors,",
        autumnDesc4: "a spectacular autumn view.",
        winter: "Winter",
        winterName: "Ice Paradise",
        winterDesc1: "Winter at Dagu Glacier,",
        winterDesc2: "ice-covered branches,",
        winterDesc3: "snowy peaks in view,",
        winterDesc4: "a frozen highland paradise.",
      },
    },
    panoramaGallery: {
      title: "Gallery",
      spring: {
        seasonTitle: "Spring Gallery",
        title: "Spring · Flowers & Snow",
        subtitle:
          "Spring at Dagu Glacier—half snow-capped peaks, half flowers in the valleys, a unique highland scene.",
      },
      summer: {
        seasonTitle: "Summer Gallery",
        title: "Summer · Cool Retreat",
        subtitle:
          "Summer at Dagu Glacier—forests embrace joy, glacier lakes bring coolness, a secret highland escape.",
      },
      autumn: {
        seasonTitle: "Autumn Gallery",
        title: "Autumn · Colorful Forests",
        subtitle:
          "Autumn at Dagu Glacier—red leaves ignite the forests, glaciers enhance the colors, a spectacular autumn view.",
      },
      winter: {
        seasonTitle: "Winter Gallery",
        title: "Winter · Ice Paradise",
        subtitle:
          "Winter at Dagu Glacier—ice-covered branches, snowy peaks in view, a frozen highland paradise.",
      },
    },
    scenicIntro: {
      bannerLoading: "Loading banner...",
      collapse: "Collapse",
      expand: "Expand",
      characteristicLandscape: "Featured Landscapes",
      noLandscape: "No featured landscapes",
      comingSoonHint: "More content coming soon",
    },
    productTours: {
      sunshineSnow: {
        title: "Sunshine Snow Tour",
        heroAria: "Sunshine Snow Tour",
        previewAria: "Sunshine Snow Tour highlights",
        detailAria: "Sunshine Snow Tour details",
        imageLoadFailed: "Image failed to load",
        introLines: [
          "Snow dances on the glacier peaks, while peach blossoms bloom beside Golden Monkey Sea.",
          "Let Fangsheng Lake wash away the noise of daily life,",
          "offer a blessing for good fortune at Hongyun Slope,",
          "recall the Long March at Red Army Bridge and taste Tibetan delicacies,",
          "and make promises of lasting love beside Tear Lake.",
        ],
        cards: [
          { id: "ig28", title: "Upper Dagu Tibetan Village" },
          { id: "ig29", title: "Golden Monkey Sea Boardwalk" },
          { id: "ig30", title: "Hongyuan Village" },
        ],
        spots: [
          {
            id: "shang-dagu",
            title: "Upper Dagu Tibetan Village",
            paragraphs: [
              "Hidden deep in Dagu Glacier, Upper Dagu Tibetan Village is one of the Three Dagu villages and a well-preserved Amdo Tibetan settlement at about 3,800 meters above sea level. First established in the Ming dynasty, it carries a long cultural history.",
              "The village climbs along the slope with red-and-blue houses scattered through the mist. Traditional customs remain vibrant here, and the site also preserves memories of the Red Army's passage during the Long March. Walking through the village, visitors can enjoy glacier and forest views while experiencing authentic Tibetan hospitality and the calm depth of a highland settlement.",
            ],
          },
          {
            id: "jin-hou-hai",
            title: "Golden Monkey Sea Boardwalk",
            paragraphs: [
              "The Golden Monkey Sea Boardwalk is a hidden first stop after entering Dagu Glacier. It winds beside the lake through primeval forest, accompanied by streams and frequent encounters with Tibetan macaques. The mix of lake reflections, colorful woodland, and fluttering prayer flags makes it one of the liveliest scenic spots in the park.",
            ],
          },
          {
            id: "hong-yuan-zhai",
            title: "Hongyun Slope",
            paragraphs: [
              "Hongyun Slope lies in the Dagu River Valley at 3,600 to 3,700 meters above sea level. It is a glacial erratic landscape left behind by Quaternary glaciers. Orange algae growing on the stones create vivid rust-red tones against streams and alpine scenery.",
              "A local legend says the Red God of Wealth once appeared here, so the slope has become a popular place for blessings and good wishes. In every season, red stones, snow mountains, and colorful forests combine into a striking blend of nature and local culture.",
            ],
          },
        ],
      },
      iceSummer: {
        title: "Ice Summer Tour",
        heroAria: "Ice Summer Tour",
        detailAria: "Ice Summer Tour details",
        introLines: [
          "Stroll through flower corridors stretching for miles and immerse yourself in the scents and sounds of Dagu.",
          "Ride the world-class cableway to see ten thousand acres of rhododendrons in bloom,",
          "circle Mount Logos for blessings and fulfilled wishes,",
          "and enjoy the cool, oxygen-rich air around Camel Ridge and Zenacuo Lake all summer long.",
        ],
        spots: [
          {
            id: "rhododendron",
            title: "Ten-Thousand-Acre Rhododendron Forest",
            paragraphs: [
              "Dagu Glacier's vast rhododendron forest is often praised as China's premier alpine rhododendron destination, rooted across plateau slopes from 3,800 to 4,200 meters.",
              "From May to June, red, pink, white, and purple blossoms spread across the mountains like a floral sea. The densest clusters gather near Golden Monkey Sea, where Tibetan macaques sometimes move through the flowers, blending wild charm with alpine beauty.",
            ],
          },
          {
            id: "mountain",
            title: "Mount Logos",
            paragraphs: [
              "In Tibetan, Mount Logos means 'guardian of the mountains.' Rising above 4,000 meters, it is one of the spiritual landmarks of Dagu Glacier. The main ridge resembles a sleeping beauty and a giant Buddha, giving the mountain a distinctive silhouette.",
              "Legends of sisters transforming into lakes, clusters of mani stones, and long prayer flags all add to its sacred atmosphere. Rare wildlife and forest trails make it a place where nature and belief meet in every season.",
            ],
          },
          {
            id: "lake",
            title: "Dongcuo Sun-Moon Lake",
            paragraphs: [
              "Dongcuo Sun-Moon Lake is a jewel of Dagu Glacier at about 4,300 meters and the park's largest glacial lake. Two linked basins form a dumbbell-like shape, and the green water shines like sapphire beneath the snow peaks and alpine meadows.",
              "Its scenery shifts through the year: in winter it becomes a natural ice-and-snow field, and in summer it glows like a gem set into the mountains. Revered by local Tibetans as a sacred lake, it is one of the most memorable views from the cableway.",
            ],
          },
        ],
      },
      snowMountainForest: {
        title: "Snow Mountain Forest Tour",
        heroAria: "Snow Mountain Forest Tour",
        miniCardsAria: "Snow Mountain Forest Tour highlights",
        detailAria: "Snow Mountain Forest Tour details",
        introLines: [
          "In golden autumn, forests blaze with color across valleys, snowy peaks, villages, and lakes.",
          "In the homeland of the Kasidawen intangible heritage tradition,",
          "glaciers shine crystal clear and snow mountains rise above the clouds,",
          "while colorful forests create one of Asia's most striking alpine autumn landscapes.",
        ],
        miniCards: [
          { title: "Sorbus King" },
          { title: "Niubianzi" },
          { title: "Hongyun Slope" },
        ],
        spots: [
          {
            id: "flower-king",
            title: "Sorbus King",
            paragraphs: [
              "The Sorbus King of Dagu Glacier is one of the signature sights in the colorful forest core area. Deeply rooted in alpine soil, this long-lived tree stands tall with a broad crown and striking seasonal character.",
              "In early summer, white blossoms cover the branches like fresh snow. In autumn, fiery red leaves and glossy berries glow against the snowy highland light, making it a vivid symbol of the plateau's vitality.",
            ],
          },
          {
            id: "niubianzi",
            title: "Niupengzi",
            paragraphs: [
              "Niupengzi lies beside Sacred Ox Lake near Red Army Bridge and is one of the best places to enjoy Dagu's colorful autumn forests. At around 3,500 meters above sea level, red sorbus, yellow birch, and evergreen pines layer the slopes with plateau autumn colors.",
              "From National Day through mid-November, sunlight filters through the forest and creates shifting shadows, turning the landscape into a highland pastoral scene flowing beneath the snowy mountains.",
            ],
          },
          {
            id: "hongyunpo",
            title: "Hongyun Slope",
            paragraphs: [
              "Hongyun Slope lies in the Dagu River Valley at 3,600 to 3,700 meters above sea level. It is a glacial erratic landscape left behind by Quaternary glaciers. Orange algae growing on the stones create vivid rust-red tones against streams and alpine scenery.",
              "A local legend says the Red God of Wealth once appeared here, so the slope has become a popular place for blessings and good wishes. In every season, red stones, snow mountains, and colorful forests combine into a striking blend of nature and local culture.",
            ],
          },
        ],
      },
      glacierScience: {
        title: "Glacier Science Tour",
        heroAria: "Glacier Science Tour",
        pairAria: "Glacier Science Tour preview",
        sectionsAria: "Glacier Science Tour sections",
        summitAria: "Glacier Summit 4860",
        introLines: [
          "Play in the snow at Lovers' Beach and admire ice around Lingyun Waterfall.",
          "Let the snowfields of Luobi Pasture spark youthful imagination, with Dagu Lake as a natural skating ground.",
          "Watch the lively macaques in Lower Dagu and sip coffee at 4,860 meters above sea level.",
          "Stand atop Dagu and face the endless mountains below for a true high-altitude challenge.",
        ],
        sections: [
          {
            id: "lover-lake",
            title: "Lovers' Beach",
            desc: "Lovers' Beach presents the romantic side of Dagu Glacier. Local stories tell of a chieftain's daughters and three village brothers who fell in love, meeting in secret at the glacier's foot with songs, vows, and an unforgettable first kiss witnessed by the mountains. The spot has since become a place to celebrate devotion under the sacred peaks.",
          },
          {
            id: "village-view",
            title: "Tibetan Macaque Viewing Area",
            desc: "The Tibetan macaque viewing area is a natural place to get close to one of Dagu Glacier's most charming wild residents. Visitors can often watch entire groups foraging and playing at close range, enjoying a vivid encounter between people and the alpine ecosystem.",
          },
        ],
        summit: {
          title: "Glacier Summit 4860",
          paragraphs: [
            "Glacier Summit 4860 is one of Dagu Glacier's core landmarks at the upper cableway station. At 4,860 meters above sea level, ancient glaciers, year-round snow, and rolling seas of clouds create one of the most dramatic viewpoints in the scenic area.",
            "The world's highest cloud-top coffee house is also here. With panoramic windows opening onto the snow mountains and mani piles adding ritual meaning, the summit combines natural grandeur with a rare sense of human warmth and wonder.",
          ],
        },
      },
      redCulture: {
        title: "Red Culture Tour",
        heroAria: "Red Culture Tour",
        sculptureAria: "Red Army Sculpture Group",
        detailAria: "Red Culture Tour details",
        introLines: [
          "Follow the Long March footsteps on Changde Snow Mountain and remember the original mission at Red Army Bridge.",
          "Listen to history by Red Army Lake, trace faith through historic meeting sites,",
          "carry the honor of revolutionary memory at Hongyun Slope and in the red culture exhibition hall,",
          "and walk the old route again to feel the courage and responsibility that still shape the mountains and rivers of today.",
        ],
        sculpture: {
          title: "Red Army Sculpture Group",
          text: "The Red Army Sculpture Group, titled 'Northward, Northward,' stands in the valley below Red Army Bridge as one of Dagu Glacier's key red culture landmarks. It captures the epic journey of the Red Army crossing snowy mountains and marching through Heishui, preserving revolutionary memory within the plateau landscape.",
        },
        spots: [
          {
            id: "changde",
            title: "Changde Snow Mountain",
            paragraphs: [
              "Changde Snow Mountain is located in Shashiduo Township, Heishui County, Aba Prefecture, Sichuan, at an elevation of 4,283 meters. It was one of the crucial snowy peaks crossed by the Red Army during the Long March. In early July 1935, the First Front Army overcame severe hardship here and crossed the mountain with the help of local Tibetan people.",
              "Today, Changde Village at the foot of the mountain is known as a 'red village.' Each Dragon Boat Festival, young villagers carry offerings up the mountain to honor the martyrs and continue the spirit of the Long March. Changde is not only a mountain of nature, but also a mountain of memory and national spirit.",
            ],
          },
          {
            id: "red-army-lake",
            title: "Red Army Lake",
            paragraphs: [
              "Red Army Lake lies in the heart of Dagu Glacier and carries the memory of the Long March. After crossing the more than 4,200-meter-high Changde Snow Mountain in 1935, the Red Army once camped here. Local Tibetans later named the lake in honor of that achievement.",
              "The calm, deep green water mirrors the perseverance associated with the Red Army. Beyond witnessing hardship and endurance, the lake also preserves memories of solidarity between soldiers and local people, making it an important stop on Dagu's red tourism route.",
            ],
          },
          {
            id: "red-army-bridge",
            title: "Red Army Bridge",
            paragraphs: [
              "Red Army Bridge stands in the river valley of Sandagu Village inside the scenic area. In July 1935, the Red Army fought to seize this crossing while moving north. The temporary wooden bridge became a key passage, and local residents later named it Red Army Bridge in memory of the soldiers who passed here.",
              "With glacier meltwater rushing below and Tibetan houses scattered nearby, the bridge connects both landscape and history. It remains an important carrier of the Long March spirit of sacrifice and endurance.",
            ],
          },
        ],
      },
    },
    scenicSpotIntroductionViews: {
      heroAlt: "Scenic view",
      defaultImageAlt: "Scenic view",
      detail: {
        title: "Dagu Lake",
        paragraphs: [
          "In Tibetan, 'Da' means glacier and 'Gu' means deep valley, so Dagu can be understood as 'the glacier in a deep ravine.' Dagu Lake is formed by meltwater from ancient glaciers, and its colors change with the seasons.",
          "Above the snow peaks and across the ice fields, the lake invites a quiet conversation with the self. Here you can meditate, sing, or simply set aside worldly concerns and speak sincerely to the sacred mountain, the sky, and the person you love.",
          "In spring, sunlight filters through the forest canopy, buds break from dark branches, and wildflowers spread along the lakeshore in soft shades of fresh green and gold.",
          "In autumn, the colorful forest reflects on the lake, turning the water into a shifting palette while flocks of wild ducks move across the surface, creating a natural painting with the distant mountains.",
        ],
      },
      gallery: [
        { id: 1, title: "Panoramic View of Dagu Lake" },
        { id: 2, title: "Primeval Forest" },
      ],
    },
    study: {
      heroAlt: "Dagu Glacier",
      fiveResources: "Five Study Resources",
      fiveTravels: "5 Study Journeys",
      studySystem: '"1+8+N" Dagu Glacier Study System',
      outdoorStations: "8 Outdoor Study Stations",
      oneCoreHub: "1 Core Study Hub",
      coreHubDesc:
        "Study Center: The Dagu Glacier Study Center has a total construction area of 1,200㎡, divided into 5 functional areas including Interstellar Glacier, Glacier Landforms, Glacier Guardians, Glacier Culture, and Glacier Biology, covering 6 theme classrooms, 5 laboratories, 4 theme exhibition halls, 1 streaming media classroom, and 1 lecture hall.",
      resources: {
        r1Title: "01 Glacier Geological Remains",
        r1Sub:
          "Core Value: World's youngest glacier, closest to major cities, most accessible glacier",
        r1Desc1:
          "Dagu Glacier formed 2 million years ago and is one of the few modern maritime glacier distribution areas on the eastern edge of the Qinghai-Tibet Plateau influenced by the southeast monsoon. It is the northernmost maritime modern mountain glacier in China, known by geological experts as the 'Glacier Relic Garden'.",
        r1Desc2:
          "It features various glacier types including cirque glaciers, hanging glaciers, and slope glaciers. The typical glacial landforms (such as cirques, glacier arc arches, and arêtes) as well as fold geological landscapes make it a 'living fossil' and 'natural laboratory' for studying Quaternary glacial activities, climate change processes, and geomorphic evolution patterns.",
        r2Title: "02 Vertical Ecosystem",
        r2Sub:
          "Core Value: From 2,300m at the foot to 4,860m at the summit, the alpine vertical zonation of plants is distinct, presenting a 'vertical canvas of biodiversity'.",
        r2Desc:
          "It hosts nationally protected plants including Taxus chinensis (Class I), and Sinopodophyllum hexandrum, Meconopsis punicea, and Kingdonia uniflora (Class II), showcasing their morphological characteristics and survival wisdom. Wildlife includes Sichuan golden monkeys, snow leopards, and blue sheep. It is a brilliant treasure trove of biodiversity and a model of ecological transition zones.",
        r3Title: "03 Mars-like Landforms",
        r3Sub:
          "Core Value: The U-shaped valleys, cirques, and whaleback rock groups of Dagu Glacier are highly similar to the lobate debris aprons (LDA) and glacier-like forms (GLF) on Mars. Both may contain water ice or record paleoclimate information, making it an ideal analog site for planetary geology and extraterrestrial habitability research - an 'Earth-based Mars classroom'.",
        r4Title: "04 Glacier Protection Experiment",
        r4Sub:
          "Core Value: Over 6 consecutive years of glacier protection ('glacier blanket') experiments have achieved significant results, reducing glacier melt thickness by 2.3 meters, with an estimated 75% reduction in glacier ablation.",
        r4Desc1:
          "Estimated 75% reduction in glacier ablation. The 'glacier blanket' experimental principle: how does traditional geotextile work?",
        r4Desc2:
          "Nanomaterials and traditional geotextile methods for protecting glaciers differ fundamentally in principle.",
        r4Desc3:
          "Traditional geotextiles are active, reducing glacier melt by blocking heat exchange between the atmosphere and the glacier;",
        r4Desc4:
          "New radiative cooling nanomaterials are passive, consuming no energy, reducing glacier melt by minimizing energy input, enhancing solar reflectance, and increasing mid-infrared window energy emission.",
        r5Title: "05 Red Memory & Folk Heritage",
        r5Sub1:
          "Core Value: Dagu Glacier is the only 4A scenic area traversed by the Red Army during the Long March. The Red Army crossed Changde Snow Mountain and Dagu Snow Mountain, leaving behind Red Army Lake, Red Army Bridge, and stories like 'Eating Ice Cream' - a 'Red Monument under the Snow Mountains'.",
        r5Sub2:
          "The Jiarong Tibetans living around the scenic area contrast with the Amdo Tibetans within the area. Their unique languages, costumes, religions, architecture, music and dance, and ecological wisdom of harmonious coexistence with nature represent 'Wisdom between Sacred Mountains and Lakes'.",
      },
      travels: {
        t1: "{'|'} World's Youngest Glacier Landform Decoding Journey",
        t2: "{'|'} China's Only Global Endangered Glacier Guardian Journey",
        t3: "{'|'} Long March Footprints and Folk Coexistence Journey",
        t4: "{'|'} Eastern Qinghai-Tibet Plateau Alpine Biodiversity Vertical Zonation Discovery Journey",
        t5: "{'|'} Earth's Closest Mars-like Glacier Valley Study Journey",
      },
      stations: {
        s1: "{'|'} Snow Realm Wildlife Study Station",
        s2: "{'|'} Dagu Tibetan Village Study Station",
        s3: "{'|'} Red Army Bridge Study Station",
        s4: "{'|'} Red Stone Beach Study Station",
        s5: "{'|'} Dagu Lake Study Station",
        s6: "{'|'} Glacier Wetland Study Station",
        s7: "{'|'} Relic Garden Study Station",
        s8: "{'|'} 4860 Mars-like Landform Study Station",
        s9: "{'|'} N Special Study Classrooms",
      },
      centerImgAlt: "Center Image",
      stationImgAlt: "Station",
      travelAlt: "Travel",
      specialClassroom: "{'|'} N Special Study Classrooms",
    },
    honors: {
      title: "Honors & Titles",
      all: "All",
      yearSuffix: "",
      yearTitle: "Annual",
      noHonors: "No honors available",
      comingSoonHint: "More honors coming soon",
    },
    glacierExperiment: {
      title: "Glacier Experiment",
      noContent: "No content",
      comingSoonHint: "More glacier experiment content coming soon",
      pageNumber: "Page",
      jump: "Go",
    },
    glacierResearch: {
      title: "Folk Culture",
      noContent: "No content",
      comingSoonHint: "More {title} content coming soon",
      pageNumber: "Page",
      jump: "Go",
    },
  },
  newsListPage: {
    mockItems: [
      {
        title: "Winter events at Dagu Glacier are now open",
        summary: "Highlights and visitor reminders",
      },
      {
        title: "Traffic guide updated",
        summary: "Driving and public transport suggestions",
      },
    ],
  },
  newsDetailPage: {
    sampleTitle: "Sample news title",
    sampleContent:
      "<p>Sample content will appear here after it is published in CMS.</p><p>Rich text is supported, including:</p><ul><li>List item 1</li><li>List item 2</li></ul>",
  },
  serviceTipsPage: {
    sampleContent:
      "<p>Visitor tips content will appear here once it is published in CMS.</p>",
  },
  serviceLeisurePage: {
    mockItems: [
      "Sample leisure content",
      "Sample: recommended activities and experiences",
    ],
  },
  panoramaLivePage: {
    defaultLocations: [
      "Lovers' Beach at Dagu Lake",
      "Jinbao Sea",
      "Zenaco",
      "Thousand-mile Colorful Forest",
      "Mount Logos",
      "Cableway Upper Station",
    ],
  },
  panoramaDaguErPage: {
    mockAuthor: "FROM: Dagu Photographer {index}",
  },
};
